import { generateUtilityClasses } from '@mui/material';

// generateUtilityClasses가 이미 타입을 제공하므로 별도 인터페이스 불필요
export const breadcrumbsClasses = generateUtilityClasses('Breadcrumbs', [
  'root',
  'item',
  'separator',
  'expandButton',
]);
